import { formatSelfiePeriodLabel, toISODate } from './selfiePeriod';

function addDaysISO(isoDate, days) {
  const date = new Date(`${isoDate}T12:00:00`);
  date.setDate(date.getDate() + days);
  return toISODate(date);
}

function averageClosedCycleDays(completed) {
  if (completed.length < 2) return 30;
  let total = 0;
  for (let i = 1; i < completed.length; i += 1) {
    const prev = new Date(`${completed[i - 1].snapshot_date}T12:00:00`);
    const cur = new Date(`${completed[i].snapshot_date}T12:00:00`);
    total += Math.round((cur - prev) / (24 * 60 * 60 * 1000));
  }
  return Math.max(7, Math.floor(total / (completed.length - 1)));
}

/**
 * Ciclos delimitados pelas datas das selfies concluídas (``snapshot_date``).
 * @param {Array} snapshots — timeline / lista de MonthlySnapshot
 * @param {string} [firstCycleStartISO] — início do 1.º ciclo (ex. API)
 */
export function listSelfieCyclesFromSnapshots(
  snapshots = [],
  referenceDate = new Date(),
  firstCycleStartISO = null,
) {
  const today = toISODate(referenceDate);
  const completed = [...snapshots]
    .filter((s) => s.is_completed !== false && s.snapshot_date)
    .sort((a, b) => a.snapshot_date.localeCompare(b.snapshot_date));

  const closed = [];
  for (let index = 0; index < completed.length; index += 1) {
    const snap = completed[index];
    const prev = completed[index - 1];
    let start = prev
      ? addDaysISO(prev.snapshot_date, 1)
      : firstCycleStartISO || snap.snapshot_date;
    if (start > snap.snapshot_date) {
      start = snap.snapshot_date;
    }
    closed.push({
      start,
      end: snap.snapshot_date,
      label: formatSelfiePeriodLabel(start, snap.snapshot_date),
      isCurrent: false,
      snapshotId: snap.id,
    });
  }

  const last = completed[completed.length - 1];
  const currentStart = last ? addDaysISO(last.snapshot_date, 1) : firstCycleStartISO || today;
  const horizonDays = averageClosedCycleDays(completed);
  const projectedEnd = addDaysISO(currentStart, horizonDays - 1);
  const currentEnd = [projectedEnd, today, currentStart].reduce((max, iso) => (iso > max ? iso : max));
  const cycles = [
    ...closed,
    {
      start: currentStart,
      end: currentEnd,
      label: formatSelfiePeriodLabel(currentStart, currentEnd),
      isCurrent: true,
      snapshotId: null,
    },
  ];

  cycles.sort((a, b) => (a.start < b.start ? 1 : -1));
  return cycles;
}

/** Normaliza resposta de ``GET /api/snapshots/cycles/``. */
export function normalizeSelfieCycles(apiRows = []) {
  return (apiRows || []).map((row) => ({
    start: row.start,
    end: row.end,
    label: formatSelfiePeriodLabel(row.start, row.end),
    isCurrent: Boolean(row.is_current),
    snapshotId: row.snapshot_id,
    defaultStart: row.default_start ?? null,
    minStart: row.min_start ?? null,
    maxStart: row.max_start ?? null,
    isStartCustomized: Boolean(row.is_start_customized),
    defaultEnd: row.default_end ?? null,
    minEnd: row.min_end ?? null,
    maxEnd: row.max_end ?? null,
    isEndCustomized: Boolean(row.is_end_customized),
  }));
}

export function expenseMatchesCycleFilters(expense, filters) {
  if (!filters?.occurred_on_from || !filters?.occurred_on_to || !expense?.occurred_on) {
    return true;
  }
  return (
    expense.occurred_on >= filters.occurred_on_from
    && expense.occurred_on <= filters.occurred_on_to
  );
}
